/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const addUserRoles = createAsyncThunk(
  "user/addUserRoles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addUserRoles", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUserRoleById = createAsyncThunk(
  "user/getUserRoleById",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/v1/user/${userId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUserRoles = createAsyncThunk(
  "user/updateUserRoles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put("/api/admin/updateUserRoles", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put("/api/admin/v1/user", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUserList = createAsyncThunk(
  "user/getUserList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/v1/user");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deactivateUser = createAsyncThunk(
  "user/deactivateUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/deactivateUser", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrgList = createAsyncThunk(
  "user/getOrgList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getKarncyOrganisations");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllCities = createAsyncThunk(
  "user/getAllCities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllCities");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const setTemporaryPassword = createAsyncThunk(
  "user/setTemporaryPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/setTemporaryPassword", payload);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resetMfa = createAsyncThunk(
  "user/resetMfa",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/resetMfa", payload);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getRegionalManagers = createAsyncThunk(
  "user/getRegionalManagers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/regionalManager");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const UserSlice = createSlice({
  name: "user",
  initialState: {
    userList: [],
    user: {},
    orgList: [],
    allCities: [],
    loading: false,
    error: null,
    addUserLoading: false,
    deactivateLoading: false,
    regionalManagers: [],
  },

  extraReducers: (builder) => {
    builder.addCase(getUserList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUserList.fulfilled, (state, action) => {
      state.loading = false;
      state.userList = action.payload;
      state.error = null;
    });
    builder.addCase(getUserList.rejected, (state, action) => {
      state.loading = false;
      state.userList = [];
      state.error = action.payload;
    });

    builder.addCase(getUserRoleById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUserRoleById.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    });
    builder.addCase(getUserRoleById.rejected, (state, action) => {
      state.loading = false;
      state.user = {};
      state.error = action.payload;
    });

    builder.addCase(addUserRoles.pending, (state) => {
      state.error = null;
      state.addUserLoading = true;
    });
    builder.addCase(addUserRoles.fulfilled, (state, action) => {
      state.error = null;
      state.addUserLoading = false;
    });
    builder.addCase(addUserRoles.rejected, (state, action) => {
      state.error = action.payload;
      state.addUserLoading = false;
    });

    builder.addCase(updateUserRoles.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(updateUserRoles.fulfilled, (state, action) => {
      state.addUserLoading = false;
      state.error = null;
    });
    builder.addCase(updateUserRoles.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    builder.addCase(updateUser.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.addUserLoading = false;
      state.error = null;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deactivateUser.pending, (state) => {
      state.deactivateLoading = true;
      state.error = null;
    });
    builder.addCase(deactivateUser.fulfilled, (state, action) => {
      state.deactivateLoading = false;
      state.error = null;
    });
    builder.addCase(deactivateUser.rejected, (state, action) => {
      state.deactivateLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getOrgList.fulfilled, (state, action) => {
      state.orgList = action.payload;
    });

    builder.addCase(getAllCities.fulfilled, (state, action) => {
      state.allCities = action.payload;
    });

    builder.addCase(getRegionalManagers.fulfilled, (state, action) => {
      state.regionalManagers = action.payload;
    });
  },

  reducers: {
    clearAuthError: (state) => {
      state.error = null;
    },
  },
});

export const { clearAuthError } = UserSlice.actions;

export default UserSlice.reducer;
